<template>
  <v-container-with-title
    title="Clasificaciones"
    subtitle="Ordenadas de acuerdo a cuántos QMIs tienen sin tener asociado un QMP de QMatch."
  >
    <!-- A component to search for a classification id or name -->
    <v-classifications-search />
    <!-- The table with the classifications -->
    <v-classifications-table />
  </v-container-with-title>
</template>

<script>
import VClassificationsSearch from "./Search";
import VClassificationsTable from "./Table";
import VContainerWithTitle from "@/components/containers/ContainerWithTitle";

export default {
  components: {
    VClassificationsSearch,
    VClassificationsTable,
    VContainerWithTitle
  }
};
</script>